"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapAlgoliaQuerySuggestionsToQuerySuggestions = void 0;
const mapAlgoliaQuerySuggestionsToQuerySuggestions = (querySuggestion) => {
    return {
        query: querySuggestion.query,
        querySuggestionId: querySuggestion.objectID,
        popularity: querySuggestion.popularity,
        // eslint-disable-next-line no-underscore-dangle
        highlightedQuery: querySuggestion._highlightResult?.query?.value,
    };
};
exports.mapAlgoliaQuerySuggestionsToQuerySuggestions = mapAlgoliaQuerySuggestionsToQuerySuggestions;
//# sourceMappingURL=mapAlgoliaQuerySuggestionsToQuerySuggestions.js.map